export default __webpack_public_path__ + "static/media/diagonaldown_darktolight.ca47ad62.png";